import IMask from 'imask';
import AxiosForm from '../../model/form/AxiosForm';
import { yaTag } from '../../middleware/yandex/yandex.tag';

export function validatePhones() {
  const inputs = document.querySelectorAll('input[type="tel"]');
  [...inputs].forEach((input) => {
    const masked = validatePhone(input);
    input.addEventListener('focus', () => {
      const val = input.value;
      masked.updateOptions({ lazy: false });
      masked.value = val;
    }, true);

    input.addEventListener('blur', () => {
      masked.updateOptions({ lazy: true });
    });
  });
}

document.validatePhones = () => validatePhones();

export function maskDigitsOnly() {
  const inputs = document.querySelectorAll('[data-mask-digits]');
  [...inputs].forEach((input) => {
    IMask(input, {
      mask: /^\d+$/,
    });
  });
}

/**
 * @param {HTMLInputElement} input - type tel
 */
export function validatePhone(input) {
  const maskOptions = {
    mask: '+{7} (000) 000-00-00',
  };
  return IMask(input, maskOptions);
}

/**
 * Валидация поля advertising в зависимости от наличия и заполненности поля email
 * @param {HTMLFormElement} form - форма для валидации
 */
export function validateAdvertisingField(form) {
  const emailField = form.querySelector('input[name*="email"]');
  const advertisingField = form.querySelector('input[name*="advertising"]');

  if (emailField && advertisingField) {
    const updateAdvertisingRequired = () => {
      if (emailField.value && emailField.value.trim() !== '') {
        advertisingField.required = true;
      } else {
        advertisingField.required = false;
      }
    };

    updateAdvertisingRequired();
  }
}

export function validateForms() {
  const forms = document.querySelectorAll('.needs-validation');
  Array.prototype.filter.call(forms, (form) => {
    const hasProducts = (form.querySelector('[data-send-products]') !== null);

    form.addEventListener(
      'submit',
      async (event) => {
        const title = form.parentElement.parentElement.querySelector('.form-title') === null
          ? form.parentElement.parentElement.querySelector('.modal-title')
          : form.parentElement.parentElement.querySelector('.form-title');

        event.preventDefault();
        event.stopPropagation();

        form.classList.add('was-validated');

        const submit = form.querySelector('button[type="submit"]');
        const hasProductId = (form.querySelector('#order-items-product-id')?.value !== '');

        validateAdvertisingField(form);

        if (form.checkValidity() === true && hasProductId) {
          AxiosForm.sendForm(form, title).then(async (response) => {
            if (response
                && (response.status === 200 || response.status === 201)
                && submit !== null
                && submit.dataset.afterSuccessYaTag !== null) {
              await yaTag(
                submit.dataset.afterSuccessYaTag,
                null,
                form.closest('[data-parent]')?.dataset.parent,
              );
            }
            if (hasProducts && response.status === 200) {
              closeModalOnButtonAfterProductsSubmit(form);
            }
          });
        }
      },
      false,
    );
  });
}

/**
 * @param {HTMLFormElement} form
 */
const closeModalOnButtonAfterProductsSubmit = (form) => {
  form.closest('.modal').querySelector('.modal-close')
    .addEventListener('click', () => {
      window.location.reload();
    });
};

export function validateNumberInput() {
  const elements = document.querySelectorAll("input[type='number']");
  Array.prototype.filter.call(elements, (el) => {
    el.addEventListener('focusout', (e) => {
      const productId = Number(e.currentTarget.closest('[data-cart-product-id]').dataset.cartProductId);

      if (Number(el.value) < Number(el.min)) {
        el.value = el.min;
      } else if (Number(el.value) > Number(el.max)) {
        el.value = el.max;
      }
      window.Dio.SHOP.CART_PREORDER.changeTotal(productId);
      window.Dio.SHOP.CART_WISHLIST.changeTotal(productId);
    });

    el.oninput = () => {
      if (Number(el.value) < 0) {
        el.value = el.min;
      }
    };
  });
}

/**
 * Check on empty filepond if required
 *
 * @param {HTMLFormElement} form
 * @param {FilePond} filepond
 */

export function validateFilePondRequired(form, filepond) {
  const pond = form.querySelector('.filepond--root');
  const tooltip = form.querySelector('.filepond--required-error');

  pond?.addEventListener('FilePond:addfile', () => {
    tooltip.style.display = 'none';
    filepond?.element.classList.remove('filepond--error-required');
  });

  form.onsubmit = () => {
    if (filepond?.getFiles().length === 0 && filepond?.element.querySelector('input').required) {
      tooltip.style.display = 'block';
      filepond?.element.classList.add('filepond--error-required');
    }
  };

  $(form.closest('.modal')).on('hidden.bs.modal', (event) => {
    filepond.removeFiles();
  });
}

export function feedbackStatement(feedback, state = false) {
  if (state) {
    feedback.style.display = 'block';
  } else {
    feedback.style.display = 'none';
  }
}

export function textareaCounter() {
  const textAreaParents = document.querySelectorAll('.textarea-counter');
  if (textAreaParents !== null) {
    textAreaParents.forEach((textAreaParent) => {
      const counter = textAreaParent.querySelector('.counter');
      const textarea = textAreaParent.querySelector('textarea');
      const text_max = textarea.maxLength;
      $(counter).html(`${$(textarea).val().length} / ${text_max}`);

      $(textarea).keyup(() => {
        $(counter).html(`${$(textarea).val().length} / ${text_max}`);
      });
    });
  }
}
